import { put, call } from "redux-saga/effects";
import { clientQuery } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager";
// Actions
import { reportsMainGenerateReportProgress } from "Redux/actions";

import { getTimeZone } from "Modules/reports/views/main/components/reportsTab/helper";

function* getDriverFormsSummaryReport(report, event) {
  const { timeZone, name,reportTimeRanges } = report;
  const { startRange, endRange } = report.filters;
  const {
    filterType,
    filterArray,
    page,
    rowsPerPage,
    sortField,
    sortOrder,
    otherFilters,
  } = event.filters;
  try {
    const newReport = JSON.parse(JSON.stringify(report));
    let data = yield call(
      clientQuery,
      `query getDriverFormsDetailsReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
          Report: getDriverFormsDetailsReport (conditions: $conditions, limit: $limit, offset: $offset) {
            items {
              driverId
              dateTime
              address
              form
              question
              answer
              latitude
              longitude
            }
            total
            limit
            offset
            category
            reportInstanceId
          }
        }`,
      {
        conditions: {
          reportName: name,
          category: {
            field: filterType,
            value: filterArray?.driverId,
          },
          timeZone: getTimeZone(timeZone),
          dateRange: {
            fields: ["unitTime"],
            GTE: startRange,
            LTE: endRange,
            reportTimeRanges
          },
          sortField: {
            field: sortField || "deviceId",
            order: sortOrder === "desc" ? "DESC" : "ASC",
          },
          stringValues: {
            values: otherFilters?.form
          }
        },
        limit: rowsPerPage,
        offset: page,
      },
      endpoints.GRAPHQL_PX_REPORTING
    );

    if (data?.Report) {
      newReport.summary = data.Report;
      newReport.loadingSummary = false;
      yield put(reportsMainGenerateReportProgress(newReport));
    } else {
      newReport.loadingSummary = false;
      yield put(reportsMainGenerateReportProgress(newReport));
    }
  } catch (exc) {
    report.loadingSummary = false;
    ExceptionManager(
      exc,
      "src/modules/reports/views/main/components/reportsTab/.components/reports/engineHoursReports",
      "getDriverFormsSummaryReport"
    );
    yield put(reportsMainGenerateReportProgress(report));
  }
}

export default getDriverFormsSummaryReport;
